export default "__VITE_ASSET__DgvrUu7j__"